import { BASE_URL } from "../utils/constants";
import handler from "../utils/handler";
import { clearAllLocalStorage } from "../utils/localStorageManager";

export const GetLedgerSearch = async (value) => {
	const accessToken = sessionStorage.getItem("accessToken");

	try {

		const headers = {
			"Content-Type": "application/json",
		}

		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/ledger/search`, {
			method: "POST",
			headers,
			body: JSON.stringify(value)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};


		let result = handler(response)
		
		return result;

	} catch (e) {
		throw e;
	}
}

export const GetLedgerSummary = async (value) => {
	const accessToken = sessionStorage.getItem("accessToken");

	try {

		const headers = {
			"Content-Type": "application/json",
		}

		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/ledger/search/summary`, {
			method: "POST",
			headers,
			body: JSON.stringify(value)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};


		let result = handler(response)
		
		return result;

	} catch (e) {
		throw e;
	}
}

export const GetKpiStatistics = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {
		
		const headers = {
			"Content-Type": "application/json",
		}

		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/ledger/kpi/statistics`, {
			method: "POST",
			headers,
			body: JSON.stringify(value)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}